import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.sclang = languageMap.supercollider = bracketIndenting()
